import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-multi-carousel/lib/styles.css";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import FluidBackground from "./FluidBackground";
import {
  AllcommercialsDetail,
  Allcommercialsinnerpage,
  alldocumentartiesinnerpage,
  alllongformatinnerpage,
  commercials,
  documentaries,
  longformat,
} from "./data/CategoryData";
import DummyVideo from "./components/DummyVideo/DummyVideo";

// const Home = lazy(() => import("./pages/Home/Home"));
// const HomewithYt = lazy(() => import("./pages/Home/HomewithYt"));
// const Header = lazy(() => import("./components/Header/HeaderNew"));
// const Footer = lazy(() => import("./components/Footer/Footer"));
// const Services = lazy(() => import("./pages/services/Services"));
// const Career = lazy(() => import("./pages/career/Career"));
// const Founder = lazy(() => import("./pages/founders/Founder"));
// const Contact = lazy(() => import("./pages/contactpage/contactpage"));
// const Gallery = lazy(() => import("./pages/gallery/GalleryNew"));
// const Client = lazy(() => import("./pages/clients/Client"));
// const Media = lazy(() => import("./pages/media/MediaNew"));
// const VideoPage = lazy(() => import("./pages/Playerpage/VideoPage"));
// const AboutUs = lazy(() => import("./pages/aboutUs/AboutUs"));
// const Index = lazy(() => import("./pages/CategoryPage/Index"));
// const Detail = lazy(() => import("./pages/CategoryPage/Detail"));
// const Shortdocumentaries = lazy(() =>
//   import("./pages/CategoryPage/ShortDocumentaries")
// );
// const Commercials = lazy(() => import("./pages/CategoryPage/Commercials"));
// const CommercialsNew = lazy(() =>
//   import("./pages/CategoryPage/CommercialsNew")
// );
// const LongFormat = lazy(() => import("./pages/CategoryPage/LongFormatNew"));
// const SubCategoryPage = lazy(() => import("./pages/upcoming/SubCategoryPage"));

import Home from "./pages/Home/Home";
import HomewithYt from "./pages/Home/HomewithYt";
import Header from "./components/Header/HeaderNew";
import Footer from "./components/Footer/Footer";
import Services from "./pages/services/ServicesNew";
import Career from "./pages/career/Career";
import Founder from "./pages/founders/FounderNew";
import Contact from "./pages/contactpage/contactpage";
import Gallery from "./pages/gallery/GalleryNew";
import Client from "./pages/clients/Client";
import Media from "./pages/media/MediaNew";
import VideoPage from "./pages/Playerpage/VideoPage";
import AboutUs from "./pages/aboutUs/AboutUs";
import Index from "./pages/CategoryPage/Index";
import Detail from "./pages/CategoryPage/DetailNew";
import Shortdocumentaries from "./pages/CategoryPage/ShortDocumentaries";
import Commercials from "./pages/CategoryPage/Commercials";
import CommercialsNew from "./pages/CategoryPage/CommercialsNew";
import LongFormat from "./pages/CategoryPage/LongFormatNew";
import LongFormat2 from "./pages/CategoryPage/LongFormatNew2";
import LongFormat3 from "./pages/CategoryPage/LongFormatNew3";
import SubCategoryPage from "./pages/upcoming/SubCategoryPage";

const App = () => {
  const location = useLocation();
  const isVideoPage = location.pathname.startsWith("/watch");

  useEffect(() => {
    Aos.init({
      duration: 800,
      offset: 40,
      // disable: window.innerWidth < 1279,
      // once: true,
    });
  }, []);

  return (
    <>
      <div>
        <FluidBackground />
        <ScrollToTop />
        <Header />
        {/* {!isVideoPage && (
          <Suspense fallback={<div>Loading...</div>}>
            <Header />
          </Suspense>
        )} */}
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<HomewithYt />} />

          <Route path="long-format" element={<Index />}>
            <Route path="" element={<LongFormat pageHeading="Long Format" />} />
            {/* <Route path="details/:id/:videoId" element={<Detail />} /> */}
            <Route
              path="details/:videoId"
              element={<Detail pageHeading="Long Format" />}
            />
            <Route
              path="all"
              element={
                <SubCategoryPage
                  headingText="All Films And Web Shows"
                  pageHeading="Long Format > All"
                  data={alllongformatinnerpage}
                />
              }
            />
            <Route path="all/details/:id/:videoId" element={<Detail />} />
          </Route>

          <Route path="short-documentaries" element={<Index />}>
            <Route
              path=""
              element={
                <Shortdocumentaries pageHeading="Shorts & Documentaries" />
              }
            />
            <Route
              path="details/:videoId"
              element={<Detail pageHeading="Shorts & Documentaries" />}
            />
            <Route
              path="all"
              element={
                <SubCategoryPage
                  headingText="Upcoming"
                  pageHeading="Shorts & documentaries > Upcoming"
                  data={alldocumentartiesinnerpage}
                />
              }
            />
            <Route path="all/details/:id/:videoId" element={<Detail />} />
          </Route>

          <Route path="commercials" element={<Index />}>
            <Route
              path=""
              element={<CommercialsNew pageHeading="Commercials" />}
            />
            <Route path="details/:id/:videoId" element={<Detail />} />
            <Route path="all/details/:id/:videoId" element={<Detail />} />
            <Route
              path="all"
              element={
                <SubCategoryPage
                  headingText="All Commercials"
                  pageHeading="Commercials > All"
                  data={Allcommercialsinnerpage}
                />
              }
            />
          </Route>
          <Route
            path="/long-format-2"
            element={<LongFormat2 pageHeading="Long Format" />}
          />
          <Route
            path="/long-format-3"
            element={<LongFormat3 pageHeading="Long Format" />}
          />
          <Route path="/services" element={<Services />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/dummyvideo" element={<DummyVideo />} />
          <Route path="/founders" element={<Founder />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/clients" element={<Client />} />
          <Route path="/media" element={<Media />} />
          {/* <Route path="/watch/:videoId" element={<VideoPage />} /> */}
          <Route path="/watch/:videoId" element={<Detail />} />
          <Route path="/about-us" element={<AboutUs />} />
        </Routes>
        {/* </Suspense> */}
        {/* {!isVideoPage && (
          <Suspense fallback={<div>Loading...</div>}>
            <Footer />
          </Suspense>
        )} */}
        <Footer />
        <div className="fixed z-40 bottom-[4vw] right-[4vw] md:bottom-[1.5vw] md:right-[1.5vw] !size-[48px] sm:!size-[46px] md:!size-[54px] 3xl:!size-[75px]">
          <a
            href="https://wa.me/+919029500400"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/contact/whatsapp.png"
              alt="whatsapp"
              className="w-full h-full object-cover"
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default App;
